module.exports = __webpack_public_path__ + "img/svg/instagram.64e4e2fcf4bb1be914795a5a7ca2dcf2.svg";